import { render } from "./createPublicPersonStepOne.vue?vue&type=template&id=82c488a0&scoped=true"
import script from "./createPublicPersonStepOne.vue?vue&type=script&lang=js"
export * from "./createPublicPersonStepOne.vue?vue&type=script&lang=js"

import "./createPublicPersonStepOne.vue?vue&type=style&index=0&id=82c488a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c488a0"]])

export default __exports__